import {useKeycloak} from '@react-keycloak/web';

export const useRoles = () => {
    const {keycloak} = useKeycloak();
    const roles = keycloak?.realmAccess?.roles || [];

    return {
        roles,
        hasRole: (role) => roles.includes(role),
        hasAnyRole: (requiredRoles) => requiredRoles.some(role => roles.includes(role)),
        hasAllRoles: (requiredRoles) => requiredRoles.every(role => roles.includes(role)),
    };
};